var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -6.86 76.624 76.624",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(-622.053 -100.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M669.458,134.413l-4.062-.674a19.473,19.473,0,0,0-2.132-5.134l2.442-3.424a1.8,1.8,0,0,0-.188-2.233l-3.481-3.478a1.788,1.788,0,0,0-2.231-.184l-3.427,2.446a19.452,19.452,0,0,0-5.134-2.121l-.674-4.045a1.79,1.79,0,0,0-1.708-1.446h-4.888a1.79,1.79,0,0,0-1.707,1.446l-.674,4.043a19.477,19.477,0,0,0-5.136,2.123l-3.424-2.446a1.786,1.786,0,0,0-2.229.184l-3.481,3.478a1.793,1.793,0,0,0-.183,2.233l2.447,3.426a19.44,19.44,0,0,0-2.124,5.132l-4,.674a1.758,1.758,0,0,0-1.409,1.707v4.891a1.756,1.756,0,0,0,1.409,1.707l4.019.674a19.342,19.342,0,0,0,2.117,5.134l-2.453,3.424a1.792,1.792,0,0,0,.181,2.233l3.479,3.478a1.788,1.788,0,0,0,2.229.184l3.428-2.447a19.416,19.416,0,0,0,5.132,2.122l.674,4.045a1.79,1.79,0,0,0,1.707,1.446h4.888a1.79,1.79,0,0,0,1.708-1.446l.674-4.042a19.394,19.394,0,0,0,5.134-2.125l3.427,2.447a1.791,1.791,0,0,0,2.231-.184l3.477-3.478a1.794,1.794,0,0,0,.188-2.233l-2.45-3.426a19.389,19.389,0,0,0,2.122-5.132l4.084-.674a1.83,1.83,0,0,0,1.485-1.707V136.12A1.832,1.832,0,0,0,669.458,134.413ZM646.5,149.7a11.136,11.136,0,1,1,11.138-11.136A11.138,11.138,0,0,1,646.5,149.7Z",
    fill: "#a9afbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M665.947,150.419a10.244,10.244,0,0,1,.052,2.664c-.07.713-1.186.746-1.17-.694S665.741,149.614,665.947,150.419Z",
    fill: "#a9afbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M626.861,153.242a17.657,17.657,0,0,1,0-2.653c.054-.593.976.167.944.781S627,154.337,626.861,153.242Z",
    fill: "#a9afbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M666.01,121.949a14.8,14.8,0,0,1,0,2.313c-.111.9-1.309.841-1.4-.226S665.759,121.025,666.01,121.949Z",
    fill: "#a9afbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M626.84,121.981a14.347,14.347,0,0,0,.017,2.493c.139.968,1.644.823,1.6-.342S627.023,120.947,626.84,121.981Z",
    fill: "#a9afbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M669.458,132.343l-4.062-.675a19.487,19.487,0,0,0-2.132-5.134l2.442-3.424a1.794,1.794,0,0,0-.188-2.232l-3.481-3.479a1.791,1.791,0,0,0-2.231-.183l-3.427,2.446a19.418,19.418,0,0,0-5.134-2.121l-.674-4.046a1.79,1.79,0,0,0-1.708-1.445h-4.888a1.79,1.79,0,0,0-1.707,1.445l-.674,4.045a19.408,19.408,0,0,0-5.136,2.122l-3.424-2.446a1.788,1.788,0,0,0-2.229.183l-3.481,3.479a1.791,1.791,0,0,0-.183,2.232l2.447,3.427a19.434,19.434,0,0,0-2.124,5.131l-4,.675a1.757,1.757,0,0,0-1.409,1.706v4.892a1.756,1.756,0,0,0,1.409,1.707l4.019.674a19.376,19.376,0,0,0,2.117,5.135l-2.453,3.423a1.79,1.79,0,0,0,.181,2.232l3.479,3.478a1.786,1.786,0,0,0,2.229.184l3.428-2.445a19.551,19.551,0,0,0,5.132,2.122l.674,4.044a1.789,1.789,0,0,0,1.707,1.445h4.888a1.789,1.789,0,0,0,1.708-1.445l.674-4.043a19.39,19.39,0,0,0,5.134-2.123l3.427,2.445a1.788,1.788,0,0,0,2.231-.184l3.477-3.478a1.793,1.793,0,0,0,.188-2.232l-2.45-3.427a19.369,19.369,0,0,0,2.122-5.131l4.084-.674a1.83,1.83,0,0,0,1.485-1.707v-4.892A1.83,1.83,0,0,0,669.458,132.343ZM646.5,147.632A11.137,11.137,0,1,1,657.636,136.5,11.138,11.138,0,0,1,646.5,147.632Z",
    fill: "#dce2e9",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M630.913,137.53a1.035,1.035,0,0,1-1.036-1.035,16.64,16.64,0,0,1,16.621-16.62,1.035,1.035,0,1,1,0,2.07,14.567,14.567,0,0,0-14.55,14.55A1.035,1.035,0,0,1,630.913,137.53Z",
    fill: "#dce2e9",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M646.5,153.116a1.036,1.036,0,0,1,0-2.071,14.566,14.566,0,0,0,14.55-14.55,1.035,1.035,0,0,1,2.07,0A16.639,16.639,0,0,1,646.5,153.116Z",
    fill: "#dce2e9",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M697.71,114.646l-2.641-.438a12.638,12.638,0,0,0-1.387-3.338l1.588-2.226a1.166,1.166,0,0,0-.122-1.451l-2.263-2.262a1.165,1.165,0,0,0-1.451-.121l-2.228,1.591a12.576,12.576,0,0,0-3.338-1.378l-.437-2.631a1.164,1.164,0,0,0-1.111-.94h-3.178a1.163,1.163,0,0,0-1.11.94l-.439,2.629a12.628,12.628,0,0,0-3.338,1.38l-2.227-1.591a1.165,1.165,0,0,0-1.451.121l-2.262,2.262a1.169,1.169,0,0,0-.121,1.451l1.593,2.228a12.7,12.7,0,0,0-1.383,3.336l-2.6.438a1.142,1.142,0,0,0-.917,1.11v3.181a1.14,1.14,0,0,0,.917,1.109l2.611.439a12.633,12.633,0,0,0,1.376,3.338l-1.594,2.226a1.167,1.167,0,0,0,.117,1.451l2.262,2.263a1.166,1.166,0,0,0,1.451.119l2.229-1.59a12.647,12.647,0,0,0,3.336,1.379l.439,2.629a1.162,1.162,0,0,0,1.11.941h3.178a1.164,1.164,0,0,0,1.111-.941l.437-2.627a12.65,12.65,0,0,0,3.338-1.381l2.228,1.59a1.166,1.166,0,0,0,1.451-.119l2.262-2.263a1.169,1.169,0,0,0,.121-1.451l-1.592-2.228a12.7,12.7,0,0,0,1.38-3.336l2.654-.439a1.188,1.188,0,0,0,.967-1.109v-3.181A1.19,1.19,0,0,0,697.71,114.646Zm-14.927,9.941a7.241,7.241,0,1,1,7.239-7.24A7.241,7.241,0,0,1,682.783,124.587Z",
    fill: "#ca902b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M695.429,125.054a6.775,6.775,0,0,1,.032,1.732c-.045.464-.771.484-.76-.452S695.293,124.53,695.429,125.054Z",
    fill: "#ca902b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M670.015,126.889a11.149,11.149,0,0,1,0-1.724c.035-.387.635.107.614.507S670.1,127.6,670.015,126.889Z",
    fill: "#ca902b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M695.469,106.542a9.822,9.822,0,0,1,0,1.5c-.072.589-.851.547-.914-.148S695.306,105.941,695.469,106.542Z",
    fill: "#ca902b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M670,106.564a9.22,9.22,0,0,0,.013,1.62c.089.63,1.069.535,1.037-.222S670.119,105.891,670,106.564Z",
    fill: "#ca902b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M697.71,113.3l-2.641-.439a12.638,12.638,0,0,0-1.387-3.338l1.588-2.227a1.165,1.165,0,0,0-.122-1.45l-2.263-2.263a1.163,1.163,0,0,0-1.451-.119l-2.228,1.59a12.644,12.644,0,0,0-3.338-1.379l-.437-2.63a1.164,1.164,0,0,0-1.111-.94h-3.178a1.163,1.163,0,0,0-1.11.94l-.439,2.628a12.664,12.664,0,0,0-3.338,1.381l-2.227-1.59a1.163,1.163,0,0,0-1.451.119l-2.262,2.263a1.168,1.168,0,0,0-.121,1.45l1.593,2.228a12.725,12.725,0,0,0-1.383,3.337l-2.6.439a1.141,1.141,0,0,0-.917,1.109v3.18a1.14,1.14,0,0,0,.917,1.11l2.611.438a12.626,12.626,0,0,0,1.376,3.339L670.2,124.7a1.167,1.167,0,0,0,.117,1.451l2.262,2.262a1.164,1.164,0,0,0,1.451.12l2.229-1.591a12.648,12.648,0,0,0,3.336,1.38l.439,2.63a1.163,1.163,0,0,0,1.11.94h3.178a1.164,1.164,0,0,0,1.111-.94l.437-2.629a12.583,12.583,0,0,0,3.338-1.381l2.228,1.591a1.164,1.164,0,0,0,1.451-.12l2.262-2.262a1.169,1.169,0,0,0,.121-1.451l-1.592-2.228a12.692,12.692,0,0,0,1.38-3.337l2.654-.438a1.188,1.188,0,0,0,.967-1.11v-3.18A1.189,1.189,0,0,0,697.71,113.3Zm-14.927,9.94a7.241,7.241,0,1,1,7.239-7.24A7.242,7.242,0,0,1,682.783,123.241Z",
    fill: "#ffc52f",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M683.454,126.136a.673.673,0,0,1-.673.673A10.821,10.821,0,0,1,671.973,116a.673.673,0,1,1,1.346,0,9.472,9.472,0,0,0,9.462,9.46A.675.675,0,0,1,683.454,126.136Z",
    fill: "#ffc52f",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M693.589,116a.673.673,0,0,1-1.347,0,9.471,9.471,0,0,0-9.461-9.462.673.673,0,1,1,0-1.346A10.819,10.819,0,0,1,693.589,116Z",
    fill: "#ffc52f",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingSoon);
export default __webpack_public_path__ + "static/media/SettingSoon.bb58a93d9a0773d657904562f1d26894.svg";
export { ForwardRef as ReactComponent };